var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.59,
    height: 17.299,
    viewBox: "0 0 44.481 43.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6931d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b4a0f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-github",
    d: "M24.448,2.25a22.2,22.2,0,0,0-7.025,43.256c1.109.206,1.586-.475,1.586-1.063V40.67c-6.168,1.332-7.469-2.981-7.469-2.981a5.883,5.883,0,0,0-2.569-3.25c-2.014-1.364.159-1.347.159-1.347a4.662,4.662,0,0,1,3.394,2.3,4.757,4.757,0,0,0,6.469,1.839,4.646,4.646,0,0,1,1.4-2.965c-4.916-.571-10.1-2.474-10.1-10.973a8.562,8.562,0,0,1,2.283-5.962,7.928,7.928,0,0,1,.223-5.868s1.855-.6,6.1,2.268a21.089,21.089,0,0,1,11.1,0c4.234-2.87,6.089-2.268,6.089-2.268a7.928,7.928,0,0,1,.223,5.868,8.562,8.562,0,0,1,2.283,5.962c0,8.531-5.185,10.4-10.132,10.957a5.28,5.28,0,0,1,1.507,4.107v6.089c0,.73.4,1.284,1.586,1.063a22.2,22.2,0,0,0-7.1-43.257Z",
    transform: "translate(-2.25 -2.25)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github_icon.04f143000fb8fc95d69e4f2e4134c7d0.svg";
export { ForwardRef as ReactComponent };